import * as actionTypes from '../actions/actionTypes';

const initialState = {
    students: null,
    loadingStudents: false,
    availableFaculties: [],
    loadingAvailableFaculties: false
};

const loadStudents = (state) => {
    return {
        ...state,
        loadingStudents: true
    }
}

const setStudents = ( state, action ) => {
    let tmp = {...action.students}
    return {
        ...state,
        students: tmp,
        loadingStudents: false
    }
};

const loadAvailableFaculties = (state) => {
    return {
        ...state,
        loadingAvailableFaculties: true
    }
}

const setAvailableFaculties = ( state, action ) => {
    let tmp = [...action.faculties]
    return {
        ...state,
        availableFaculties: tmp,
        loadingAvailableFaculties: false
    }
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_STUDENTS: return loadStudents( state );
        case actionTypes.SET_STUDENTS: return setStudents( state, action );
        case actionTypes.LOAD_AVAILABLE_FACULTIES: return loadAvailableFaculties( state );
        case actionTypes.SET_AVAILABLE_FACULTIES: return setAvailableFaculties( state, action );
        default: return state;
    }
};
export default reducer;